import { useCallback, useEffect, useState } from 'react';

// A small hand-rolled data-fetching hook instead of pulling in a caching
// library (React Query etc.) — one admin user works one page at a time
// here, so the caching/invalidation machinery those libraries exist for
// isn't earning its dependency weight. `deps` re-runs the fetch, `reload`
// lets a mutation (create/update/delete) explicitly refresh the list.
export function useApiQuery(fetcher, deps) {
  const [state, setState] = useState({ data: null, error: null, loading: true });

  const load = useCallback(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetcher()
      .then((data) => {
        if (!cancelled) setState({ data, error: null, loading: false });
      })
      .catch((error) => {
        if (!cancelled) setState((current) => ({ ...current, error, loading: false }));
      });
    return () => {
      cancelled = true;
    };
    // `deps` is caller-supplied by design (this hook's whole contract is
    // "re-fetch when these change"), not a fixed dependency array eslint
    // could check statically.
  }, deps);

  useEffect(() => load(), [load]);

  return { ...state, reload: load };
}
